

export class FilterTruckingRouteDto {

	public idReserca: string;
	
    public filterKeys: String[];

	public searchText: string;
	
	public sliceCount: number = 100;

	public static buildPage(searchtext: string, activeFilterKeys: Array<string>): FilterTruckingRouteDto {
		let result = new FilterTruckingRouteDto();
		result.searchText = searchtext;
		result.filterKeys = activeFilterKeys;
		return result;
	}
}
